import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { AthleteService } from "../providers/athlete/athlete.service";
import { AuthService } from "../providers/auth.provider";
import { CONST } from "../providers/const";

@Injectable()
export class AthletePendingRoute implements CanActivate {
    constructor(private router: Router,
        private athleteService: AthleteService,
        private authService: AuthService) { }
    canActivate() {
        return true
    }
}